import { useQuery } from '@grandvisionhq/graphql';
import { toPrescriptionDownloads } from '../mappers/prescription-downloads.js';
import GET_PRESCRIPTION_DOWNLOADS from '../operations/queries/get-prescription-downloads.js';

const usePrescriptionDownloads = ()=>{
    var ref, ref1;
    const { data , loading , error  } = useQuery(GET_PRESCRIPTION_DOWNLOADS);
    return {
        data: (data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.prescriptions) && toPrescriptionDownloads(data === null || data === void 0 ? void 0 : (ref1 = data.me) === null || ref1 === void 0 ? void 0 : ref1.prescriptions),
        loading,
        error
    };
};
var usePrescriptionDownloads$1 = usePrescriptionDownloads;

export { usePrescriptionDownloads$1 as default };
//# sourceMappingURL=use-get-prescription-downloads.js.map
